import React from 'react'
import { useTranslation } from 'react-i18next'

/**
 * SkipLinks Component
 *
 * Provides keyboard navigation shortcuts for accessibility.
 * Links are visually hidden but become visible when focused via keyboard (Tab key).
 *
 * WCAG 2.1 Success Criterion 2.4.1 (Level A): Bypass Blocks
 */
export const SkipLinks: React.FC = () => {
  const { t } = useTranslation('common')
  return (
    <nav aria-label={t('skipToMain', 'Skip to main content')} className="skip-links">
      <a
        href="#main-content"
        className="skip-link"
      >
        {t('skipToMain', 'Skip to main content')}
      </a>
      <a
        href="#navigation"
        className="skip-link"
      >
        {t('skipToNav', 'Skip to navigation')}
      </a>
    </nav>
  )
}

SkipLinks.displayName = 'SkipLinks'
